(function () {
  'use strict';

  var isTouchDevice = window.matchMedia('(hover: none)').matches;

  // Mega menus
  document.querySelectorAll('[data-mega-menu-trigger]').forEach(function (trigger) {
    var menu = trigger.querySelector('[data-mega-menu]');
    if (!menu) return;

    if (!isTouchDevice) {
      trigger.addEventListener('mouseenter', function () { menu.classList.add('is-open'); });
      trigger.addEventListener('mouseleave', function () { menu.classList.remove('is-open'); });
    } else {
      trigger.addEventListener('click', function (e) {
        var isOpen = menu.classList.contains('is-open');
        document.querySelectorAll('[data-mega-menu].is-open').forEach(function (m) { m.classList.remove('is-open'); });
        if (!isOpen) { e.preventDefault(); menu.classList.add('is-open'); }
      });
    }
  });

  // Close mega menus on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-mega-menu].is-open').forEach(function (m) { m.classList.remove('is-open'); });
      closeMobileMenu();
    }
  });

  // Mobile menu
  var mobileMenu    = document.getElementById('lumi-mobile-menu');
  var mobileOverlay = document.querySelector('[data-mobile-overlay]');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (mobileOverlay) { mobileOverlay.classList.add('is-visible'); }
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (mobileOverlay) { mobileOverlay.classList.remove('is-visible'); }
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-menu-toggle]')) { openMobileMenu(); return; }
    if (e.target.closest('[data-mobile-menu-close]') || e.target.closest('[data-mobile-overlay]')) { closeMobileMenu(); }
  });
})();
